(function (angular, app) {
   "use strict";

   // Slider
   angular.module(app.modules.ui.name)
      .directive(app.modules.ui.directives.timepicker, TimePickerDirective);

   TimePickerDirective.$inject = ["$timeout"
      , app.modules.common.services.functions
   ];

   function TimePickerDirective($timeout
      , ggFunctions
       ) {

      var ctrl = this;

      return {
         restrict: "A"
         , templateUrl: "app/ui/directives/timepicker.html"
         , scope: {
            callback: "&"
         }
         , link: function (scope, element, attrs) {



            scope.tp = {
               list : {
                  hour : [
                  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12
                  ]
               , minute : [
                  0, 1, 2, 3, 4, 5, 6, 7, 8, 9
                  , 10, 11, 12, 13, 14, 15, 16, 17, 18, 19
                  , 20, 21, 22, 23, 24, 25, 26, 27, 28, 29
                  , 30, 31, 32, 33, 34, 35, 36, 37, 38, 39
                  , 40, 41, 42, 43, 44, 45, 46, 47, 48, 49
                  , 50 , 51, 52, 53, 54, 55, 56, 57, 58, 59
               ]
               , ampm : ["AM","PM"]
               }
               , current : {
                  hour : "8"
                  , minute : "0"
                  , ampm : "AM"
               }
               , f: {
                  formatTime: function (h, m, a) {
                     return scope.tp.f.formatNumber(h) + ":" + scope.tp.f.formatNumber(m) + " " + a;
                  }
                  , formatNumber : function (n) {
                     var s = n.toString();
                     if (s.length == 1) {
                        s = "0" + s;
                     }
                     return s;
                  }
                  ,
                  selectHour : function () {
                     scope.tp.f.timeIsChanged();
                  }
                  , selectMinute : function () {
                     scope.tp.f.timeIsChanged();
                  }
                  ,  selectAMPM : function () {
                     scope.tp.f.timeIsChanged();
                  }
                  ,  isHourSelected : function (v) {
                     if (v == scope.tp.current.hour) {
                        return true;
                     }
                  }
                  ,  isMinuteSelected : function (v) {
                     if (v == scope.tp.current.minute) {
                        return true;
                     }
                  }
                  ,  isAMPMSelected : function (v) {
                     if (v == scope.tp.current.ampm) {
                        return true;
                     }
                  }

                  ,  timeIsChanged : function () {
                     var newTime = "";
                     newTime = scope.tp.f.formatTime(scope.tp.current.hour, scope.tp.current.minute, scope.tp.current.ampm);
               
                     var data = {
                        time : newTime
                     }

                     // Parent Callback
                     scope.callback()(data);
                  }
               }
            }
           


            var loadOptions = function (objStr, isUpdate) {
               if (objStr) {
                  var obj = JSON.parse(objStr);
                  if (obj) {

                     if (obj.currentTime) {
                        var tm = obj.currentTime;

                        if (tm.indexOf(":") == -1) {
                           tm = ggFunctions.parseDBTime(tm,true);
                        }else{
                           if (tm.indexOf(" ") > -1){
                              tm = tm.split(" ")[0];
                           }
                        }
                        var ary = tm.split(":");



                        scope.tp.current.hour = Number(ary[0]).toString();
                        scope.tp.current.minute = Number(ary[1]).toString();

                        if (Number(scope.tp.current.hour) > 12) {
                           scope.tp.current.hour = (Number(scope.tp.current.hour) - 12).toString();
                           scope.tp.current.ampm = "PM";
                        }
                     }

                     scope.tp.f.timeIsChanged();

                  }
               }
            }

            // Watch for Change in Options
            attrs.$observe('options', function () {
               var optStr = attrs.options;
               if (optStr != "") {
                  loadOptions(optStr, true);
               }
            });

         }
      }
   }
}(angular, app));
